class Query {
    constructor(name) {
        this.name = name;
    }

    async execute(params) {
        throw "Subclass responsibility";
    }
}

export default Query;
